<template>
    <table class="ReportMetaRow">
        <tr>
            <td>{{ title }}</td>
            <td>{{ value }}</td>
        </tr>
    </table>
</template>

<script>
export default {
    name: 'ReportMetaRow',

    props: {
        title: { type: String, required: true },
        value: { type: String | Number, required: true },
    },
}
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.ReportMetaRow {

}
</style>
